<template>
  <div class="ticket">
    <div class="content">
      <div class="query">
          <div class="top">
            <div class="popup-type" @click="handleChoice('type')"><div class="text">{{queryTypeTitle}}</div><div class="division"></div><span class="huisuiyunfont">{{'\ue634'}}</span></div>
            <div class="popup-time" @click="handleChoice('time')"><div class="time">{{queryDateTitle}}</div><div class="division"></div><span class="huisuiyunfont">{{'\ue633'}}</span></div>
            <div class="checked-all">
              <van-checkbox :value="checkedAll" shape="square" icon-size="16px" @click="handleCheckChange">
                <div class="checked-all-text" slot="default">
                  全选
                </div>
              </van-checkbox>
            </div>
            <!-- <div v-show="showBottom" class="eliminate" @click="handleCancel">清除</div> -->
          </div>
          <div class="bottom">
            <div>
              <l-tab
                isBlueLine
                backgroundColor="#fff"
                titleActiveColor="#3378FF"
                titleInactiveColor="#7A8699"
                :tabList="tabList"
                :handleChange="handleChange"
              ></l-tab>
            </div>
          </div>
        </div>
      <div class="table-list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad"
          >
              <div class="within-height">
                <l-card v-if="closeCard" :cardList="cardList" :handleGetCardLenght="handleGetCardLenght"></l-card>
              </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <div v-show="showBottom" class="submit">
      <div class="left">
        <div class="sheets">已选择<span class="length">{{length}}</span>张发票, <span></span>合计金额（元）</div>
        <div>{{Number(amount).toFixed(2)}}</div>
      </div>
<!--      <div class="money" @click="handleSubmit">发起报销</div>-->
    </div>
    <div class="collection-click" @click="handleSubmit">
      <i class="allIconFont"> {{'\ue6e9'}}</i>
      <span>去报销</span>
    </div>
    <l-popup :show.sync="monthPopup" :callBack="callBack"></l-popup>
    <l-popup :show.sync="typePopup" :callBack="typeCallBack"></l-popup>
  </div>
</template>
<script>
import Observer from '@utils/observer'
import { Sticky, PullRefresh, List, Notify, Empty, Checkbox } from 'vant'
import Tab from '@/components/Tab/index.vue'
import moment from 'moment'
import Popup from '@/components/NewPopup/index.vue'
import TicketHolderCard from '@/components/TicketHolderCard/index.vue'
import { mapActions, mapState } from 'vuex'
import { isArray } from 'highcharts'
import { isSameByInvoiceCode } from '@utils/basicUtil'
export default {
  components: {
    'l-tab': Tab,
    'l-card': TicketHolderCard,
    'l-popup': Popup,
    [Sticky.name]: Sticky,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Checkbox.name]: Checkbox,
    [Notify.name]: Notify,
    [Empty.name]: Empty
  },
  async mounted () {
    await this.editCheckedAll(false)
    if (sessionStorage.invoiceType) {
      let invoice = JSON.parse(sessionStorage.invoiceType)
      this.query.invoiceType = invoice.type
      this.queryTypeTitle = invoice.title
    }
    if (sessionStorage.month) {
      let month = JSON.parse(sessionStorage.month)
      this.query.startDrewDate = month.startDrewDate
      this.query.endDrewDate = month.endDrewDate
      this.queryDateTitle = month.title
    }
    Observer.setFunction({
      type: 'changeCompany',
      fn: this.companyChangeRefresh
    })
  },
  computed: {
    ...mapState('ticketCenter', ['cardList', 'total', 'checkedAll']),
    camera: (vm) => {
      return vm.$refs.camera
    }
  },
  async activated () {
    await this.editCheckedAll(false)
    this.oldSelCardList = sessionStorage.oldSelCardList ? JSON.parse(sessionStorage.oldSelCardList) : []
    if (sessionStorage.selCardList) {
      this.selectList = JSON.parse(sessionStorage.selCardList)
      await this.onRefresh()
    } else {
      this.handleCancel()
    }
  },
  watch: {
    queryTypeTitle (v) {
      sessionStorage.invoiceType = JSON.stringify({
        type: this.query.invoiceType,
        title: v
      })
    },
    queryDateTitle (v) {
      sessionStorage.month = JSON.stringify({
        title: v,
        startDrewDate: this.query.startDrewDate,
        endDrewDate: this.query.endDrewDate
      })
    },
    async length (v) {
      // 长度是零，就清空勾选状态
      if (v === 0) {
        await this.editCheckedAll(false)
        return
      }
      let oldSelCardList = []
      if (sessionStorage.oldSelCardList) {
        oldSelCardList = JSON.parse(sessionStorage.oldSelCardList)
      }
      let sureSelectLength = this.cardList.filter(i => Number(i.reimbursementFlag) === 0 && i.invoiceSource !== 1).length
      sureSelectLength += oldSelCardList.length
      const flag = sureSelectLength === v
      await this.editCheckedAll(flag)
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      showInput: false,
      oldSelCardList: [],
      selectList: [],
      queryTypeTitle: '全部类型',
      queryDateTitle: '请选择日期',
      monthPopup: {
        flag: false,
        selectTitle: '请选择月份',
        style: { height: '50%' },
        type: 'month'
      },
      typePopup: {
        flag: false,
        selectTitle: '请选择类型',
        style: { height: '50%' },
        type: 'invoiceType'
      },
      refreshing: false,
      closeCard: true,
      amount: 0,
      length: 0,
      showBottom: false,
      query: {
        current: 0,
        size: 25,
        startDrewDate: '',
        endDrewDate: '',
        status: '',
        invoiceType: '',
        reimStatus: ''
      },
      tabList: [
        {
          title: '全部',
          index: 0
        }, {
          title: '待审批',
          index: 1
        }, {
          title: '已驳回',
          index: 2
        }, {
          title: '已通过',
          index: 3
        }
      ]
    }
  },
  methods: {
    ...mapActions('ticketCenter', ['getCardList', 'initGardList', 'selectAll', 'editCheckedAll']),
    handleSubmit () {
      // 发起报销
      if (this.$store.state.user && this.$store.state.user.menuList) {
        if (!this.$store.state.user.menuList.find(item => item.moduleUrl === '/reimbursement/launch-reim')) {
          Notify({ type: 'danger', message: '暂无权限，操作此按钮' })
          return
        }
        this.$router.push('/reimbursement/launch-reim')
      }
    },
    async handleCheckChange () {
      let oldSelCardList = []
      if (sessionStorage.oldSelCardList) {
        oldSelCardList = JSON.parse(sessionStorage.oldSelCardList)
      }
      let flag = true
      oldSelCardList.forEach(oldI => {
        if (this.cardList.find(i => isSameByInvoiceCode(oldI, i))) {
          flag = false
        }
      })
      if (!this.checkedAll && !this.cardList.some(i => Number(i.reimbursementFlag) === 0 && i.invoiceSource !== 1) && flag) {
        return Notify({ type: 'danger', message: '当前页已无可勾选的发票!' })
      }
      await this.editCheckedAll(!this.checkedAll)
      this.showBottom = this.checkedAll
      await this.selectAll()
      let sum = 0
      let invoiceList = JSON.parse(sessionStorage.selCardList) || []
      if (invoiceList && isArray(invoiceList)) {
        invoiceList.forEach(item => {
          sum += Number(item.amountWithTax)
        })
        this.handleGetCardLenght(invoiceList.length, sum)
      }
    },
    collecBack (urls) {
      this.$store.commit('invoice/changeOssUrlList', urls)
      this.$router.push('/newInvoice/newCollect')
    },
    async companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/ticket/center/index') {
        sessionStorage.clear()
        this.length = 0
        this.showBottom = false
        await this.editCheckedAll(false)
        await this.onRefresh()
      }
    },
    async onRefresh () {
      await this.initGardList()
      this.query.current = 0
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    callBack (item) {
      console.log(item)
      this.monthPopup.flag = false
      if (item === 'recovery') {
        this.queryDateTitle = '请选择日期'
        this.query.startDrewDate = ''
        this.query.endDrewDate = ''
        this.handleCancel()
        return
      }
      let monthMoment = moment()
      if (item.title) {
        monthMoment = moment(item.id + '-' + (Number(item.index) >= 10 ? item.index : '0' + item.index))
      }
      this.queryDateTitle = monthMoment.format('YYYY年MM月')
      this.query.startDrewDate = monthMoment.startOf('month').format('YYYY-MM-DD')
      this.query.endDrewDate = monthMoment.endOf('month').format('YYYY-MM-DD')
      this.handleCancel()
    },
    cutSuccess (data) {
      this.$store.commit('invoice/changeImage', data)
      this.$router.push('/newInvoice/collect')
    },
    async handleChange (v) {
      if (v === 0) {
        this.query.reimStatus = ''
      } else if (v === 1) {
        this.query.reimStatus = 1
      } else if (v === 2) {
        this.query.reimStatus = 3
      } else if (v === 3) {
        this.query.reimStatus = '2,5'
      }
      await this.onRefresh()
    },
    typeCallBack (item) {
      this.typePopup.flag = false
      if (item === 'recovery') {
        this.queryTypeTitle = '全部类型'
        this.query.invoiceType = ''
        this.handleCancel()
        return
      }
      this.queryTypeTitle = item.title
      this.query.invoiceType = item.index
      this.handleCancel()
    },
    async onLoad () {
      if (this.refreshing) {
        await this.initGardList()
        this.refreshing = false
      }
      this.query.current = this.query.current + 1
      await this.getCardList(this.query)
      this.loading = false
      if (this.cardList.length >= Number(this.total)) {
        this.finished = true
      }
    },
    handleGetCardLenght (length, sum) {
      if (length > 0) {
        this.showBottom = true
      } else {
        this.showBottom = false
      }
      this.amount = sum
      this.length = length
    },
    handleChoice (type) {
      if (type === 'type') {
        this.typePopup.flag = true
      } else if (type === 'time') {
        this.monthPopup.flag = true
      }
    },
    async handleCancel () {
      sessionStorage.clear()
      this.closeCard = false
      setTimeout(async () => {
        this.closeCard = true
        await this.onRefresh()
      }, 10)
    }
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
